module.exports = __webpack_public_path__ + "img/step2-b.7751f6e1.png";